export default {
  MuiInputBase: {
    input: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: '#ECEFF1',
      },
    },
  },
  MuiInput: {
    underline: {
      '&::before': {
        border: 'none',
      },
      '&::after': {
        border: 'none',
      },
      '&:hover:not(.Mui-disabled):before': {
        border: 'none',
      },
    },
  },
  MuiInputLabel: {
    outlined: {
      '&.MuiInputLabel-shrink': {
        transform: 'scale(0)',
      },
    },
  },
  MuiOutlinedInput: {
    root: {
      backgroundColor: '#FFFFFF',
      height: 56,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#26A69A',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#26A69A',
        borderWidth: '1px',
      },
    },
    multiline: {
      height: 'unset',
    },
  },
  MuiFormHelperText: {
    root: {
      fontSize: 12,
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Input.js